module.exports = __webpack_public_path__ + "static/media/kitchen3.24916ccd.jpg";